module.exports = __webpack_public_path__ + "img/软件下载.e30265d6.jpg";